
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DLAuthorization } from './authorization';
import { Apollo } from 'apollo-angular';
import { map as _map } from 'lodash';

const AccountsQuery = require('./gql/authorizations.query.gql');

const createDLAuthorizationMutation = require('./gql/create-authorization.mutation.gql');
const deleteDLAuthorizationMutation = require('./gql/delete-authorization.mutation.gql');

export class DLAuthorizationFilter {
  account: string
  company: string
}


@Injectable()
export class DLAuthorizationService {

  constructor(private apollo: Apollo) { }

  authorizations(filter: DLAuthorizationFilter): Observable<DLAuthorization[]> {
    return this.apollo
      .query({
        query: AccountsQuery,
        variables: {
          filter
        },
        fetchPolicy: 'no-cache'
      }).pipe(
      map((result) => {
        return _map(result.data['dlAuthorizations'], item => new DLAuthorization(item));
      }));
  }

  create(authorization: DLAuthorization): Observable<DLAuthorization> {
    return this.apollo
      .mutate({
        mutation: createDLAuthorizationMutation,
        variables: {
          input: authorization.toCreateDLAuthorizationInput()
        }
      }).pipe(
      map(result => new DLAuthorization(result.data['createDLAuthorization'])));
  }

  delete(id: string): Observable<string> {
    return this.apollo
      .mutate({
        mutation: deleteDLAuthorizationMutation,
        variables: {
          id
        }
      }).pipe(
      map(result => result.data['deleteDLAuthorization']));
  }
}
